import { Matrix3, ShaderMaterial, Uniform, Vector2, Vector4 } from 'three';
import standardVertexShader from 'shared/renderingEngine/shaders/StandardVertexShader.glsl';
import gradientShader from 'shared/renderingEngine/shaders/GradientShader.glsl';
import { Gradient, Palette } from '../../interfaces/planogram';
import { resolvePaletteVector4 } from '../../utils/colors';
import { PLANOGRAM_CONFIG } from '../../config/PlanogramConfig';

export default class GradientMaterial extends ShaderMaterial {
  constructor(pointCount: number) {
    const uniforms = {
      pointPositions: new Uniform([]),
      pointColors: new Uniform([]),
      planogramUV: new Uniform([]),
      blendPower: new Uniform(1.0),
    };
    const defines: Record<string, string> = {
      POINT_COUNT: pointCount.toString(),
      TORUS_WIDTH: PLANOGRAM_CONFIG.width.toFixed(1),
    };

    super({
      vertexShader: standardVertexShader,
      fragmentShader: gradientShader,
      defines,
      uniforms,
      transparent: true,
    });
  }

  update(gradient: Gradient, planogramMatrix: Matrix3, palette: Palette | undefined) {
    this.uniforms.pointColors.value = gradient.points.map(it =>
      resolvePaletteVector4(it.color, it.opacity, palette),
    );
    this.uniforms.pointPositions.value = gradient.points.map(it => new Vector2(it.x, it.y));
    this.uniforms.planogramUV.value = planogramMatrix;
    this.uniforms.blendPower.value = gradient.blendPower;
  }
}
